import * as helpers from "./index";
import * as filtersType from "../constants/filters";
import { checkExist, simplestText } from "./utilityHelpers";
import * as kDefaults from "../constants/defaults";

export const sortByActive = (list, name, att = "name") => {
  list.filter((item) =>
    helpers.simplestText(item[att]).includes(helpers.simplestText(name))
  );
};
export const filterByName = (list, name = "", att = "name") => {
  list.filter((item) =>
    helpers.simplestText(item[att]).includes(helpers.simplestText(name))
  );
};

export const checkHasPartOfText = (mainText = "", partText = "") => {
  // Removing spaces
  mainText = mainText.replace(/\s+/g, "");
  partText = partText.replace(/\s+/g, "");
  return helpers
    .simplestText(mainText)
    .includes(helpers.simplestText(partText));
};

export const orderActivitiesBy = (activities, orderBy) => {
  switch (orderBy) {
    case filtersType.FILTER_ORDER_BY_A_TO_Z:
      return helpers.sortByAttribute(activities, "name");
    case filtersType.FILTER_ORDER_BY_Z_TO_A:
      return helpers.sortByAttribute(activities, "name", false);
    case filtersType.FILTER_ORDER_BY_HIGHLIGHT:
      return helpers.sortByInnerAttribute(activities, "highlight", "value");
    case filtersType.FILTER_ORDER_BY_PUBLICATION_DATE:
      return helpers.sortByAttributeID(activities, "id", false);
    case filtersType.FILTER_ORDER_BY_POPULARITY:
      return helpers.sortByAttribute(activities, "popularity", true);
    default:
      return helpers.sortByAttributeID(activities, "id", false);
  }
};

const filterAbilityHelper = (activities, activeFilters = {}, typeUser) =>
  activities.filter((game) => game.others_abilities_ids);

export const getFilteredActivities = (activities = [], activeFilters = {}) => {
  if (!Array.isArray(activities)) {
    console.error(
      "getFilteredActivities: activities is not an array",
      activities
    );
    return activities;
  }

  // Filtering activities by Name
  if (activeFilters.name?.value?.length > 0) {
    activities = activities.filter((game) =>
      simplestText(game?.name || "").includes(
        simplestText(activeFilters.name.value)
      )
    );
  }

  // Remove filtros duplicados
  activeFilters.ability_free = removeDuplicate(
    activeFilters.ability_free || {}
  );

  // FILTRA EXISTÊNCIA DA ID NOS JOGOS
  if (
    activeFilters.ability_fono?.total > 0 ||
    activeFilters.ability_paid?.total > 0 ||
    activeFilters.ability_free?.total > 0
  ) {
    activities = activities.filter((game) => {
      let hasThisFilter = false;
      (game?.others_abilities_ids || []).forEach((id) => {
        if (
          helpers.checkExist(
            activeFilters.ability_fono?.[id] ||
              activeFilters.ability_paid?.[id] ||
              activeFilters.ability_free?.[id]
          )
        ) {
          hasThisFilter = true;
        }
      });
      return hasThisFilter;
    });
  }

  // Filtering activities by difficulties
  if (activeFilters.difficulties?.total > 0) {
    activities = activities.filter((game) => {
      let hasThisFilter = false;
      Object.keys(game?.difficulties || {}).forEach((dif) => {
        if (helpers.checkExist(activeFilters.difficulties?.[dif])) {
          hasThisFilter = true;
        }
      });
      return hasThisFilter;
    });
  }

  // Filtering activities by language
  if (activeFilters.language?.total > 0) {
    const langNormalized = Object.values(activeFilters.language || {}).map(
      (l) => simplestText(l)
    );
    activities = activities.filter((game) => {
      const gameLang = simplestText(game?.language || "");
      return langNormalized.includes(gameLang);
    });
  }

  // Filtering by ability_fono, ability_paid, ability_free
  if (activeFilters.ability_fono?.total > 0) {
    activities = filterAbilityHelper(
      activities,
      activeFilters.ability_fono,
      kDefaults.FONO
    );
  }

  if (activeFilters.ability_paid?.total > 0) {
    activities = filterAbilityHelper(
      activities,
      activeFilters.ability_paid,
      kDefaults.PAID
    );
  }

  if (activeFilters.ability_free?.total > 0) {
    activities = filterAbilityHelper(
      activities,
      activeFilters.ability_free,
      kDefaults.FREE
    );
  }

  // Filtering activities by type
  if (activeFilters.type?.total > 0) {
    activities = activities.filter((game) => {
      const typeKey = helpers.simplestText(game?.type || "");
      return activeFilters.type?.[typeKey] === true;
    });
  }

  // Filtering activities by min_age
  if (activeFilters.min_age?.total > 0) {
    activities = activities.filter((game) => {
      const minAge = game?.age_range?.age_min;
      return helpers.checkExist(activeFilters.min_age?.[minAge]);
    });
  }

  // Ordenação
  if (activeFilters.order_by?.total > 0) {
    activities = orderActivitiesBy(activities, activeFilters.order_by.value);
  }

  return activities;
};

// Trata habilidades free com o mesmo nome, se baseando pelas promeiras posições dos itens que se repetem. No caso, "1" e "3"
function removeDuplicate(abilities) {
  if (abilities?.hasOwnProperty("1")) {
    if (abilities["1"] !== null) {
      abilities["2"] = "2";
      abilities["4"] = "4";
      abilities["7"] = "7";
      abilities["8"] = "8";
    } else {
      abilities["2"] = null;
      abilities["4"] = null;
      abilities["7"] = null;
      abilities["8"] = null;
    }
  }
  if (abilities?.hasOwnProperty("3")) {
    if (abilities["3"] !== null) {
      abilities["5"] = "5";
      abilities["6"] = "6";
      abilities["9"] = "9";
      abilities["11"] = "11";
    } else {
      abilities["5"] = null;
      abilities["6"] = null;
      abilities["9"] = null;
      abilities["11"] = null;
    }
  }
  return abilities;
}
